import { render, staticRenderFns } from "./krisma.vue?vue&type=template&id=69d83ccc&scoped=true&"
import script from "./krisma.vue?vue&type=script&lang=js&"
export * from "./krisma.vue?vue&type=script&lang=js&"
import style0 from "./krisma.vue?vue&type=style&index=0&id=69d83ccc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d83ccc",
  null
  
)

export default component.exports